'use client';

import NotFoundKD from '@/components/kd/errors/NotFoundKD';

export default NotFoundKD;
